import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import OffsetSlider from 'components/sliders/OffsetSlider';
import InstituteCard from 'components/cards/entities/InstituteCard';
import Section from 'components/Section';

import { InstituteType } from 'propTypes/entities';

const Nature = ({ entities, subtitle }) => (
	<Section
		title="Природа России"
		url="/russia/location-russia/rubric-nature"
		align="center"
		titleSize="medium"
		subtitle={subtitle}
	>
		<OffsetSlider>
			{_(entities).map((entity) => (
				<InstituteCard
					key={entity._id}
					entity={entity}
					typeWidth="landingLandscape"
				/>
			))}
		</OffsetSlider>
	</Section>
);

Nature.propTypes = {
	entities: PropTypes.arrayOf(InstituteType).isRequired,
	subtitle: PropTypes.string
};

export default Nature;
